<div class="page-title-area">
    <div class="container-fluid">
        <div class="page-title-content">
            <h2 data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">Partners</h2>
            <ul data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">
                <li><a routerLink="/">Home</a></li>
                <li>Partners</li>
            </ul>
        </div>
    </div>
</div>

<section id="clients" class="section-bg">

    <div class="container-fluid">

        <div class="section-header pb-70 ">
            <h3>Meet Our Happy Partners </h3>

        </div>

        <div class="row no-gutters clients-wrap clearfix wow fadeInUp"
            style="visibility: visible; animation-name: fadeInUp;">

            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                <div class="client-logo">
                    <img src="assets/img/client/tech-logo.png" class="img-fluid" alt="">
                </div>
            </div>


            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                <div class="client-logo">
                    <img src="assets/img/client/client-1.png" class="img-fluid" alt="">
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                <div class="client-logo">
                    <img src="assets/img/client/client-2.png" class="img-fluid" alt="">
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                <div class="client-logo">
                    <img src="assets/img/client/client-3.png" class="img-fluid" alt="">
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                <div class="client-logo">
                    <img src="assets/img/client/client-4.png" class="img-fluid" alt="">
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                <div class="client-logo">
                    <img src="assets/img/client/client-5.png" class="img-fluid" alt="">
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                <div class="client-logo">
                    <img src="assets/img/client/client-6.png" class="img-fluid" alt="">
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                <div class="client-logo">
                    <img src="assets/img/client/client-7.png" class="img-fluid" alt="">
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                <div class="client-logo">
                    <img src="assets/img/client/client-8.png" class="img-fluid" alt="">
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                <div class="client-logo">
                    <img src="assets/img/client/client-9.png" class="img-fluid" alt="">
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                <div class="client-logo">
                    <img src="assets/img/client/client-10.png" class="img-fluid" alt="">
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                <div class="client-logo">
                    <img src="assets/img/client/client-11.png" class="img-fluid" alt="">
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                <div class="client-logo">
                    <img src="assets/img/client/client-12.png" class="img-fluid" alt="">
                </div>
            </div>



        </div>

    </div>

</section>